var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"af-badge afu-inline-flex afu-items-center afu-justify-center afu-transition afu-duration-200",class:_vm.badgeClasses},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }